module.exports = __webpack_public_path__ + "static/media/color-picker.4cfb64e3.svg";